import { useState } from 'react';
import ChangePassword from './ChangePassword';
import PersonalInformation from './PersonalInformation';
import { Button } from 'antd';
import './index.scss';

const steps = ['personal-information', 'change-password'];

export default function Profile() {
  const [step, setStep] = useState<string>(steps[0]);

  const content = () => {
    switch (step) {
      case steps[0]:
        return <PersonalInformation />;
      case steps[1]:
        return <ChangePassword />;
      default:
        return <div>Error</div>;
    }
  };

  return (
    <div>
      <div className="admin-profile-buttons">
        <Button
          type="text"
          onClick={() => setStep(steps[0])}
          className={`admin-profile-button ${
            step === steps[0] ? 'active' : ''
          }`}
        >
          Personal Information
        </Button>
        <Button
          type="text"
          onClick={() => setStep(steps[1])}
          className={`admin-profile-button ${
            step === steps[1] ? 'active' : ''
          }`}
        >
          Change Password
        </Button>
      </div>
      <div className="admin-profile-content-wrapper">{content()}</div>
    </div>
  );
}
